import { render, staticRenderFns } from "./StudentsAlsoBought.vue?vue&type=template&id=12c6c8f5"
import script from "./StudentsAlsoBought.vue?vue&type=script&lang=js"
export * from "./StudentsAlsoBought.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PreviousCourses: require('/vercel/path0/components/PreviousCourses.vue').default})
